import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';
import { Root } from '@analyzer/client';

export function useRootListQuery(projectId: string, queryParams?: { limit?: number; offset?: number }) {
  const client = useService();
  return useQuery<Root[], Error>(
    ['root-list', projectId, queryParams],
    () => client.rootList(projectId, queryParams),
    {
      keepPreviousData: true
    }
  );
}

export function useRootReadQuery(projectId: string, rootId: string) {
  const client = useService();
  return useQuery<Root, Error>({
    queryKey: ['root-read', projectId],
    queryFn: () => client.rootRead(projectId, rootId)
  });
}

export function useRootDestroyMutation(projectId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation<boolean, Error, { rootId: string }>({
    mutationFn: ({ rootId }) => client.rootDestroy(projectId, rootId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['root-list', projectId] })
  });
}

export function useRootCreateMutation(projectId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (hostname: string) => client.rootCreate(projectId, { hostname }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['root-list', projectId] })
  });
}
